import { useEffect } from 'react';
import { useUIStore } from '@/stores';
import { CheckCircle, XCircle, AlertCircle, X, Info } from 'lucide-react';

export function Toast() {
  const { toast, hideToast } = useUIStore();

  useEffect(() => {
    if (toast?.message) {
      const timer = setTimeout(() => {
        hideToast();
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [toast?.message, hideToast]);

  if (!toast?.message) return null;

  const getIcon = () => {
    switch (toast.type) {
      case 'success':
        return <CheckCircle className="w-5 h-5 text-green-400" />;
      case 'error':
        return <XCircle className="w-5 h-5 text-red-400" />;
      case 'warning':
        return <AlertCircle className="w-5 h-5 text-yellow-400" />;
      default:
        return <Info className="w-5 h-5 text-blue-400" />;
    }
  };

  const now = new Date();
  const timeStr = now.toLocaleTimeString('en-US', { 
    hour: 'numeric', 
    minute: '2-digit',
    hour12: true 
  });

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[100] animate-fade-in">
      <div 
        className="flex items-center gap-4 px-8 py-4 rounded-3xl shadow-2xl border border-gray-600/20"
        style={{ 
          background: 'linear-gradient(135deg, rgba(40, 40, 40, 0.85) 0%, rgba(60, 60, 60, 0.85) 50%, rgba(40, 40, 40, 0.85) 100%)',
          minWidth: '420px',
          backdropFilter: 'blur(10px)'
        }}
      >
        {getIcon()}
        <div className="flex-1 flex flex-col items-start">
          <p className="text-white text-lg font-medium leading-relaxed">
            {toast.message}
          </p>
          <p className="text-gray-300/70 text-sm mt-1">
            Today {timeStr}
          </p>
        </div>
        <button
          onClick={hideToast}
          className="text-gray-300/50 hover:text-gray-200 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
